module.exports = __webpack_public_path__ + "static/media/happiness-phone.504282de.png";